function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 44",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  d: "M22 0a22 22 0 1015.56 6.44A22 22 0 0022 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18 30.41a.59.59 0 01-.39-.16L11.34 24a.55.55 0 01.78-.78l5.9 5.9 15.32-15.37a.56.56 0 01.78 0 .54.54 0 010 .78L18.41 30.25a.59.59 0 01-.41.16z"
}));